export const query = (un, nombre) => `
{
                getPostgrados(cursor: 10000000, estado: true, unidad_negocio_id: ${un} ${nombre.length>0?'nombre:"'+nombre+'"':''}) {
                    id
                    nombre
                    duracion
                    creditaje
                    unidad_negocio_id
                    status
                    carga_horaria
                    unidad_duracion
                    estado
                    objetivo
                    dirigido
                    categoria {
                    id
                    nombre
                    clase_netsuite_id 
                    }
                    area {
                    id
                    nombre 
                    }
                    clasenetsuite {
                    id
                    nombre 
                    } 
                }
}
`